export const getTouchDescription = `
Have a DevOps project in mind? We're here to help. Whether you need cloud migration, 
Kubernetes setup, CI/CD automation, or ongoing infrastructure support, let's discuss 
how we can help your business scale efficiently.`;

export const adressName = `HybridOps`;
export const adress = `DevOps Services Company`;

export const phoneNumber = `Contact via Email`;

export const email = `vardan.grigoryan@hybridops.cloud`;
